import {
    SET,
    REINIT,
    ADDNOTIFICATION,
    ADD,
    RESETNOTIFICATION,
    SETSPIN
} from './types';

import {
    Actions,
} from './actions';

import {
    AddNewType
} from 'one-model-local';

/**
 * 
 * @param context contains settings.json etc
 * @param initial initial state if set
 */
export const addnew = (
    context: any,
    initial?: AddNewType,
) => {
    let initialstate = initial ||
    {
        value: false,
        notification: false,
        addnewspin: false,
        notificationmsg: "",
        addnew: {
            address: "",
            department: "",
            dob: "",
            email: "",
            id: "",
            name: "",
            phone: "",
            subTypeName: "",
            typeName: ""
        }
    };
    return (
        state: AddNewType,
        action: Actions,
    ) => {
        const {
            type,
            payload,
        } = action;
        let updated = state || initialstate;
        switch (type) {
            case SET:
                updated = {
                    ...updated,
                    value: payload?.value,
                }
                break;
            case ADDNOTIFICATION:
                updated = {
                    ...updated,
                    value: payload?.value,
                    notification: payload?.notification,
                    notificationmsg: payload?.notificationmsg,
                    addnewspin: payload?.addnewspin,
                }
                break;
            case RESETNOTIFICATION:
                updated = {
                    ...updated,
                    notification: payload?.notification,
                    notificationmsg: payload?.notificationmsg,
                }
                break;
            case SETSPIN:
                updated = {
                    ...updated,
                    addnewspin: payload?.addnewspin,
                }
                break;    
            case ADD:
                updated = {
                    ...updated,
                    addnew: payload,
                }
                break;
            case REINIT:
                updated = initialstate
                break;
        }
        return updated;
    }
};
